import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/avatares/avatar.svg'


const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = {
  key: 0,
  id: "init-quiz",
  class: "flex flex-col gap-3 w-11/12 sm:w-11/12 lg:w-8/12 xl:w-8/12"
}
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "md:min-w-[180px] w-[0%] md:w-[18%]" }, null, -1)
const _hoisted_5 = { class: "w-[100%] md:w-[90%] flex justify-between items-center" }
const _hoisted_6 = { class: "flex gap-4 items-center" }
const _hoisted_7 = { class: "flex items-center gap-1 bg-white border justify-center p-3 rounded-md shadow-sm" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex flex-col md:flex-row gap-8 items-center md:items-start" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "min-w-[150px] w-[25%] md:w-[15%] mt-0 md:mt-8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full",
    src: _imports_0,
    alt: "quiz_avatar"
  })
], -1)
const _hoisted_11 = { class: "mt-5 w-full" }
const _hoisted_12 = {
  key: 1,
  id: "result-quiz",
  class: "flex flex-col gap-3 w-100 sm:w-100 lg:w-8/12 xl:w-8/12"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "grid grid-cols-12 mt-8 gap-5 items-center" }
const _hoisted_15 = { class: "col-span-12 md:col-span-4 flex justify-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "col-span-12 md:col-span-8 flex flex-col gap-5 text-center lg:text-start" }
const _hoisted_18 = { class: "font-bold text-xl" }
const _hoisted_19 = { class: "text-sm w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_QuestionDragDropComponent = _resolveComponent("QuestionDragDropComponent")!
  const _component_QuestionTrueOrFalseComponent = _resolveComponent("QuestionTrueOrFalseComponent")!
  const _component_QuestionGapsComponent = _resolveComponent("QuestionGapsComponent")!
  const _component_QuestionComponent = _resolveComponent("QuestionComponent")!
  const _component_QuizResult = _resolveComponent("QuizResult")!
  const _component_FullModal = _resolveComponent("FullModal")!
  const _component_RecordStream = _resolveComponent("RecordStream")!
  const _component_SpeechRecognition = _resolveComponent("SpeechRecognition")!
  const _component_QuizInfo = _resolveComponent("QuizInfo")!
  const _component_MessageVoice = _resolveComponent("MessageVoice")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } }),
    _createVNode(_component_FullModal, {
      headerInfo: _ctx.headerInfo,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmModal())),
      hasIcon: true,
      hiddenCloseButton: _ctx.quizEnd,
      closeDanger: true,
      class: "bg-['#F8F9FA']"
    }, {
      content: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("main", {
          initial: _ctx.initialMotion,
          enter: _ctx.enterMotion,
          class: "flex gap-10 justify-center items-center md:items-start select-none my-4 md:px-2"
        }, [
          (_ctx.isAdaptative ? !_ctx.quizEnded : !_ctx.storeQuiz.getQuizHasEnded)
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.questionCount + 1) + "/ " + _toDisplayString(_ctx.quiz?.questionList?.length) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: " Questões", en: " Questions" })), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_CountDown, {
                        time: _ctx.quizIntro?.duration * 1000,
                        onEnd: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCountdownEnd()))
                      }, {
                        default: _withCtx(({ hours, minutes, seconds }) => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_v_icon, {
                              name: "md-watchlater-round",
                              class: "text-h-neutral-800"
                            }),
                            hours
                              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(String(hours)?.concat("h")), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", null, _toDisplayString(String(minutes)?.concat("m")), 1),
                            _createElementVNode("p", null, _toDisplayString(String(seconds)?.concat("s")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["time"]),
                      _createVNode(_component_Button, {
                        label: _ctx.answers.loading ? _ctx.$t('quiz.saving') : _ctx.answers.label,
                        class: "btn-primary p-button-sm",
                        disabled: 
                    !_ctx.answers.selected &&
                    !_ctx.answers.dragAndDropAnswers &&
                    !_ctx.answers.fillInTheBlanksAnswers &&
                    (!_ctx.answers.trueOrFalseAnswers ||
                      !_ctx.answers.allTrueOrFalseAnswered)
                  ,
                        loading: _ctx.answers.loading,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveAnswers()))
                      }, null, 8, ["label", "disabled", "loading"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.renderQuestion().type === _ctx.type.DRAG_AND_DROP)
                      ? (_openBlock(), _createBlock(_component_QuestionDragDropComponent, {
                          answers: _ctx.answers,
                          questionCount: _ctx.questionCount + 1,
                          question: _ctx.renderQuestion(),
                          key: _ctx.renderQuestion().id + _ctx.type.DRAG_AND_DROP
                        }, null, 8, ["answers", "questionCount", "question"]))
                      : (_ctx.renderQuestion().type === _ctx.type.TRUE_OR_FALSE)
                        ? (_openBlock(), _createBlock(_component_QuestionTrueOrFalseComponent, {
                            answers: _ctx.answers,
                            questionCount: _ctx.questionCount + 1,
                            question: _ctx.renderQuestion(),
                            key: _ctx.renderQuestion().id + _ctx.type.TRUE_OR_FALSE,
                            onOnAnswerSelected: _ctx.updateTrueOrFalseAnswers
                          }, null, 8, ["answers", "questionCount", "question", "onOnAnswerSelected"]))
                        : (_ctx.renderQuestion().type === _ctx.type.FILL_IN_THE_BLANKS)
                          ? (_openBlock(), _createBlock(_component_QuestionGapsComponent, {
                              answers: _ctx.answers,
                              questionCount: _ctx.questionCount + 1,
                              question: _ctx.renderQuestion(),
                              key: _ctx.renderQuestion().id + _ctx.type.FILL_IN_THE_BLANKS
                            }, null, 8, ["answers", "questionCount", "question"]))
                          : (_openBlock(), _createBlock(_component_QuestionComponent, {
                              key: 3,
                              question: _ctx.renderQuestion(),
                              answers: _ctx.answers,
                              questionCount: _ctx.questionCount + 1,
                              letter: _ctx.letter
                            }, null, 8, ["question", "answers", "questionCount", "letter"]))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_12, [
                _createVNode(_component_QuizResult, {
                  onOnProceed: _ctx.onProceed,
                  onOnPercentageQuizResult: _ctx.onPercentageQuizResult,
                  onOnClose: _ctx.onCloseQuiz,
                  learningId: 
              _ctx.quiz?.learningId ? _ctx.quiz?.learningId : _ctx.quiz?.learningObjectiveId
            ,
                  learningName: _ctx.learningName,
                  isAdaptative: _ctx.isAdaptative
                }, null, 8, ["onOnProceed", "onOnPercentageQuizResult", "onOnClose", "learningId", "learningName", "isAdaptative"])
              ]))
        ], 8, _hoisted_1)), [
          [_directive_motion]
        ])
      ]),
      _: 1
    }, 8, ["headerInfo", "hiddenCloseButton"]),
    (_ctx.isAdaptative)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _withDirectives(_createVNode(_component_RecordStream, {
            ref: "recordStream",
            encodeType: "select_item",
            timer: _ctx.TIMER
          }, null, 8, ["timer"]), [
            [_vShow, _ctx.recording]
          ]),
          (_ctx.hasSpeechRecognition)
            ? (_openBlock(), _createBlock(_component_SpeechRecognition, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_QuizInfo, {
            ref: "quizInfo",
            showTips: _ctx.showTips
          }, null, 8, ["showTips"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.hasTimeout,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hasTimeout) = $event)),
      closable: false,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      modal: true,
      showHeader: false,
      contentStyle: "background-color: #F2F8FF"
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", {
              src: require('@/assets/images/avatares/repproved.gif'),
              class: "w-100 rounded-full",
              alt: "repproved img",
              loading: "lazy"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("quiz.timeout.title")), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("quiz.timeout.info")), 1),
            _createVNode(_component_MessageVoice, {
              msg: _ctx.$t('quiz.timeout.title')?.concat(_ctx.$t('quiz.timeout.info'))
            }, null, 8, ["msg"]),
            _createVNode(_component_Button, {
              class: "btn-primary p-button-sm",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onResult(true)))
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("quiz.finalize")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}